export default "__VITE_ASSET__DKdPbq01__"